import Axios from 'axios';
import { getAuthApiBase } from './authBase';
import { mapUserSearchSortParams } from './authHelpers';

export const searchUserApi = ({
    authToken,
    deviceId,
    loginName,
    search,
    roleId,
    page,
    size,
    order,
    orderBy,
}) => {
    if (authToken != null) {
        const { sortBy, direction } = mapUserSearchSortParams({ orderBy, order });
        const pageSize = size != null && size !== '' ? size : 10;

        return Axios({
            method: 'get',
            url: getAuthApiBase() + 'v2/users/search',
            params: {
                loginName: loginName,
                fullName: search,
                roleId: roleId,
                page: page,
                sortBy,
                direction,
                pageSize,
            },
            headers: {
                authToken: authToken,
                deviceUniqueId: deviceId,
            },
        });
    }
};

export const viewUserApi = ({ authToken, deviceId, id }) => {
    if (authToken != null && id != null) {
        return Axios({
            method: 'get',
            url: getAuthApiBase() + 'v2/users/' + id + '/detail',
            headers: {
                authToken: authToken,
                deviceUniqueId: deviceId,
            },
        });
    }
};

function mapUserContact(contact) {
    if (!contact) {
        return contact;
    }
    const email = contact.emailAddress || contact.email;
    return {
        ...contact,
        email: email,
        emailAddress: email,
    };
}

export const createUserApi = ({ authToken, deviceId, data }) => {
    if (authToken != null) {
        return Axios({
            method: 'post',
            url: getAuthApiBase() + 'v2/users',
            data: {
                fullName: data.fullName,
                loginName: data.loginName,
                password: data.password,
                confirmPassword: data.confirmPassword,
                description: data.description,
                address: data.address,
                contact: mapUserContact(data.contact),
                roleIds: data.roleIds,
                submerchantCode: data.submerchantCode,
            },
            headers: {
                'Content-Type': 'application/json',
                authToken: authToken,
                deviceUniqueId: deviceId,
            },
        });
    }
};

export const updateUserApi = ({ authToken, deviceId, id, data }) => {
    if (authToken != null) {
        return Axios({
            method: 'put',
            url: getAuthApiBase() + 'v2/users/' + id,
            data: {
                fullName: data.fullName,
                loginName: data.loginName,
                description: data.description,
                address: data.address,
                contact: mapUserContact(data.contact),
                roleIds: data.roleIds,
                submerchantCode: data.submerchantCode,
            },
            headers: {
                'Content-Type': 'application/json',
                authToken: authToken,
                deviceUniqueId: deviceId,
            },
        });
    }
};

export const changeStatusUserApi = ({ authToken, deviceId, id, locked }) => {
    if (authToken != null) {
        return Axios({
            method: 'put',
            url: getAuthApiBase() + 'v2/users/' + id + '/status',
            data: {
                enabled: true,
                locked: locked,
            },
            headers: {
                'Content-Type': 'application/json',
                authToken: authToken,
                deviceUniqueId: deviceId,
            },
        });
    }
};

export const changePasswordUserApi = ({ authToken, deviceId, id, data }) => {
    return Axios({
        method: 'put',
        url: getAuthApiBase() + 'v2/users/' + id + '/password',
        data: {
            passwordOld: data.passwordOld,
            password: data.password,
            confirmPassword: data.confirmPassword,
        },
        headers: {
            'Content-Type': 'application/json',
            authToken: authToken,
            deviceUniqueId: deviceId,
        },
    });
};
